<div class="grid w-full rounded-lg bg-white">
  <span class="pb-[10px] pl-4 pt-3 text-aux-gray-dark-100">{{ card?.title }}</span>

  <div class="grid grid-cols-2 space-x-1 pb-3 pl-4 pr-[11px]">
    <div class="col-span-1 flex flex-col">
      <span class="pb-2 text-aux-blue-dark">
        {{ card?.compareFrom?.title }}
      </span>
      <span class="pb-1 text-[20px] font-medium text-aux-gray-darkest">
        {{ card?.compareFrom?.value }}
      </span>
      <span class="text-sm text-aux-green-dark">
        {{ card?.compareFrom?.percent }}
      </span>
    </div>
    <div class="col-span-1 flex flex-col">
      <span class="pb-2 text-aux-blue-dark">
        {{ card?.compareTo?.title }}
      </span>
      <span class="pb-1 text-[20px] font-medium text-aux-gray-darkest">
        {{ card?.compareTo?.value }}
      </span>
      <span class="text-sm text-aux-green-dark">
        {{ card?.compareTo?.percent }}
      </span>
    </div>
  </div>
</div>
